const defaultColor = '#E5F68C';
const halloween = '#F7A51C';

export default { defaultColor, halloween };
